import { Dispatch, FC, SetStateAction } from 'react';

import { StyleSheet } from 'react-native';
import { Divider } from 'ucl/components';

import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { spacing } from 'styles/constants';

import { WalmartLandingState } from './landing-state';
import { BlockContainer } from './styled';
import { WalmartLandingHeaderV2 } from './walmart-landing-header-v2';
import { WalmartLandingOffers } from './walmart-landing-offers/landing-offers-v2';
import { WalmartRoyalPerksMemberV2 } from './walmart-royal-perks-member-v2';
import { WalmartTerms } from './walmart-terms';

interface WalmartLandingContentProps {
  isLoyaltyUserResolved?: boolean;
  landingState: WalmartLandingState;
  handleShouldRedirect?: Dispatch<SetStateAction<boolean>>;
}

export const WalmartLandingContent: FC<WalmartLandingContentProps> = ({
  handleShouldRedirect,
  isLoyaltyUserResolved = true,
  landingState,
}) => {
  const isMobile = useIsMobileBreakpoint();
  const isWalmartLinked = landingState === WalmartLandingState.LINKED;

  if (!isLoyaltyUserResolved) {
    return null;
  }

  return (
    <>
      <BlockContainer
        style={[isMobile ? styles.mobileHeaderContainer : undefined, styles.container]}
      >
        <WalmartLandingHeaderV2 isWalmartLinked={isWalmartLinked} />
      </BlockContainer>
      <WalmartLandingOffers isAlreadyLinked={isWalmartLinked} />
      <BlockContainer style={styles.contentContainer}>
        {landingState === WalmartLandingState.LOGGED_OUT && (
          <WalmartRoyalPerksMemberV2 handleShouldRedirect={handleShouldRedirect} />
        )}
        <Divider mt="48px" mb="16px" />
        <WalmartTerms />
      </BlockContainer>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingTop: spacing.$6,
  },
  mobileHeaderContainer: {
    maxWidth: '100%',
    paddingHorizontal: 0,
  },
  contentContainer: {
    paddingBottom: spacing.$4,
  },
});
